import { render, staticRenderFns } from "./login-form.vue?vue&type=template&id=5d5c33c9&scoped=true&"
import script from "./login-form.vue?vue&type=script&lang=ts&"
export * from "./login-form.vue?vue&type=script&lang=ts&"
import style0 from "./login-form.vue?vue&type=style&index=0&id=5d5c33c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c33c9",
  null
  
)

export default component.exports